import { render } from "./EventList.vue?vue&type=template&id=5458e998"
import script from "./EventList.vue?vue&type=script&lang=js"
export * from "./EventList.vue?vue&type=script&lang=js"

import "./EventList.vue?vue&type=style&index=0&id=5458e998&lang=css"
script.render = render

export default script